import { render, staticRenderFns } from "./orderReport.vue?vue&type=template&id=99c87918&scoped=true&"
import script from "./orderReport.vue?vue&type=script&lang=js&"
export * from "./orderReport.vue?vue&type=script&lang=js&"
import style0 from "./orderReport.vue?vue&type=style&index=0&id=99c87918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c87918",
  null
  
)

export default component.exports